module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG28bb70b0fd1a42910e1813fe2846bc91.28bb70b0.png";